/* add.directive.js */

/**
 * @desc add directive that is specific to the add form module for the demandes_intervention feature
 * @example <div form-add-demande-intervention></div>
 */
(function() {
    'use strict';

    app
        .directive('formAddDemandeIntervention', formAddDemandeIntervention);

    formAddDemandeIntervention.$inject = [
        '$filter', '$rootScope',
        'crudService', 'lodashService', 'Upload'
    ];

    function formAddDemandeIntervention(
        $filter, $rootScope,
        crudService, _, Upload
    ) {

        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                site: '=?',
                context: '=',
                contratId: '=?contrat'
            },
            templateUrl: '/templates/partials/directives/forms/demandes_intervention/add_demande_intervention.html'
        };

        return directive;

        function link(scope, element, attrs) {
            const SLUG_CONTRAT_DEMANDE_INTER = 'demandes_intervention'; // Slug du contrat demande d'intervention

            scope.newDemInterModal = {
                allEquipements: [],
                equipements: [],
                prestataires_ids: [],
                listePrestataires: [],
                timer: null,
                contact: null,
                contact_phone: null,
                commentaire: "",
                file: null,
                flashMessage: {
                    success: null,
                    message: null
                },
                prestataires: null,
                equipementsSelected: []
            };
            scope.demandeInterSite = null;
            scope.siteSelectedName = null; // Site prédéfini

            scope.addEquipement = addEquipement;
            scope.choixEquipement = choixEquipement;
            scope.choixPrestataire = choixPrestataire;
            scope.closeAddEquipement = closeAddEquipement;
            scope.closeMsg = closeMsg;
            scope.openAddEquipement = openAddEquipement;
            scope.onSubmit = onSubmit;

            /**
             * Récupère le signal qui permet de récupérer tous les contrats dispo
             */
            $rootScope.$on('RequestMainCtrl::ContratCadresData', function (e, data) {
                if (data.contrats !== null || data.contrats !== undefined) {
                    scope.contrats = data.contrats;
                    if (enableAddingDemandeInter()) {
                        initForm();
                    }
                }
            });

            /**
             * Signal permettant de filtrer les équipements possibles pour une demande (sur un site spécifique)
             */
            $rootScope.$on('DirectiveDemandeInter::SelectedEquipements', function (e, data) {
                scope.equipements = data.equipements;
                scope.choixEquipement(scope.site);
            });

            
            /**
             * INIT
             * Si le contrat est défini dans la directive => initialisation du formulaire
             * Sinon, envoie d'un signal au mainCtrl afin de récupérer tous les contrats du grand compte
             * Réponse => $rootScope.$on('RequestMainCtrl::ContratCadresData')
             */
            if (scope.contratId !== undefined && scope.contratId !== null) {
                initForm();
            } else {
                $rootScope.$broadcast('RequestMainCtrl::ContratCadres');
            }

            /**
             * Initialise le formulaire de saisie
             */
            function initForm() {

                scope.formLoading = true; // Loader

                crudService.get(getUrlFeature('get-sites')).then(function (response) {
                    if (response.success) { // Ok
                        scope.newDemInterModal.categories = response.categories; // Champ categories
                        scope.newDemInterModal.types = response.types; // Champ type
                        scope.newDemInterModal.typeEquipementAutre = response.teq_autre; // Formulaire d'ajout d'équipement
                        scope.newDemInterModal.allSites = response.data; // Tous les sites
                        
                        if (scope.site === undefined || scope.site === null) {
                            // Initialise la dropdown des sites si le site n'est pas passé en param de la directive
                            $('.site_demande_inter', element).dropdown({
                                onChange: function (value, text, $selectedItem) {
                                    scope.choixEquipement(value);   // Au chgt du site, binding de la select equipement
                                }
                            });
                        } else {
                            scope.siteSelectedName = getSiteName(scope.site);
                        }

                        loadDropdown('.demande_inter_categories'); // Initialise la dropdown des categories
                        loadDropdown('.demande_inter_types'); // Initialise la dropdown des types

                    } else { // Erreur
                        scope.newDemInterModal.flashMessage = {
                            message: 'erreur_generale',
                            success: false
                        };
                    }
                    scope.formLoading = false; // Fin loader
                });
            }

            /**
             * Renvoie le nom du site
             * @param   {Int} siteId Id du site cible
             * @return  {String}
             */
            function getSiteName(siteId) {
                var name = null;
                angular.forEach(scope.newDemInterModal.allSites, function (site) {
                    if (site.id == siteId) {
                        name = site.nom;
                    }
                });

                return name;
            }

            /**
             * Envoie un signal permettant de savoir si il y a un bien un contrat Demande d'Intervention pour ce grand compte
             * Si oui => Possibilité d'ajouter des demandes
             */
            function enableAddingDemandeInter() {
                let contratCadre = _.find(scope.contrats, ['slug', SLUG_CONTRAT_DEMANDE_INTER]);
                let isEnabled = !_.isUndefined(contratCadre);

                if(isEnabled) {
                    scope.contratId = contratCadre.id;
                }

                $rootScope.$broadcast('DirectiveDemandeInter::enableAddingDemandeInter', { enable: isEnabled });
                return isEnabled;
            }

            /**
             * Renvoi un tableau d'objets composé de la valeur unique du tableau - original - ainsi que le nombre d'occurence de cette valeur
             * @param   {Array}    original Tableau à vérifier
             * @return  {Array}    Tableau d'objets
             */
            function compressArray(original) {
                var compressed = [];
                // Copie du tableau original
                var copy = original.slice(0);

                // Boucle sur tous les éléments du tableau original
                for (var i = 0; i < original.length; i++) {
                    var myCount = 0;
                    // Boucle sur tous les éléments du tableau copié et compare si c'est la même valeur
                    for (var w = 0; w < copy.length; w++) {
                        if (original[i] == copy[w]) {
                            // Incrémente le compteur de duplication
                            myCount++;
                            // Détruit la valeur
                            delete copy[w];
                        }
                    }
                    if (myCount > 0) {
                        var a = new Object();
                        a.value = original[i];
                        a.count = myCount;
                        compressed.push(a);
                    }
                }
                return compressed;
            }

            /**
             * Renvoi l'url utile pour le contrat demande d'intervention
             * (contratService.urlContrat())
             * @param   {String} fct_name Nom de la dernière partie de l'url à appeler
             * @return  {String}
             */
            function getUrlContrat(fct_name) {
                return '/contrat/' + scope.contratId + '/' + SLUG_CONTRAT_DEMANDE_INTER + '/' + fct_name;
            }

            /**
             * Renvoi l'url utile pour le contrat demande d'intervention
             * (contratService.urlFeature())
             * @param   {String} fct_name Nom de la dernière partie de l'url à appeler
             * @return  {String}
             */
            function getUrlFeature(fct_name) {
                return getUrlContrat(SLUG_CONTRAT_DEMANDE_INTER + '/' + fct_name);
            }


            /**
             * Initialise une dropdown
             * @param {String}  selector    DOM Element (jQuery style)
             * @param {Object}  options     Options de la dropdown
             */
            function loadDropdown(selector, options) {
                options = options === undefined ? {} : options;
                $(selector, element).dropdown(options);
            }

            /**
             * Initialise la dropdown des équipements ainsi que ses valeurs possibles
             */
            function choixEquipement(siteId) {
                scope.formLoading = true; // Loader

                setTimeout(function () { // Reset des valeurs de la dropdown
                    $('.demande_inter_equipments', element).dropdown('clear'); // Réinitialise la dropdown
                    $('.demande_inter_equipments', element).find('a.ui.label').each(function () { // Enlève tous les label de dropdown (Bug Semantic UI avec 'clear')
                        $(this).remove();
                    });
                }, 0);

                var params = { // Params: ID du site cible
                    id_site: siteId === undefined ? $('.site_demande_inter', element).dropdown('get value') : siteId
                };

                if ($('#modal-nouvelle-demande-intervention').find(":selected").val() != undefined) {
                    crudService.post(getUrlFeature('get-all-equipements'), params).then(function (response) {
                        if (response.success) { // Ok
                            if (!response.equipements.length) { // Aucun équipement
                                scope.newDemInterModal.flashMessage = {
                                    message: $filter('translate')('aucune_relation_equipement_prestataire'),
                                    success: false
                                };
                            } else { // Existe des équipements
                                scope.newDemInterModal.flashMessage = null;
                            }
                            scope.newDemInterModal.allEquipements = response.equipements; // Liste des équipements
                            scope.newDemInterModal.prestataires = response.prestataires; // Liste des prestas

                            if (scope.equipements !== undefined && siteId !== undefined) { // Si le site est prédéfini et que des équipements spécifiques ont été précisé
                                scope.baseEquipements = [];
                                angular.forEach(scope.newDemInterModal.allEquipements, function (equipement) { // Ajout des équipements précisés depuis la liste de tous les équipements
                                    if (scope.equipements.includes(equipement.id.toString())) { // Si l'id correspond
                                        scope.baseEquipements.push(equipement);
                                    }
                                });

                                loadDropdown('.demande_inter_equipments', {autofocus: false}); // Init dropdown des équipements
                                setTimeout(function () { // !! setTimeout sinon erreur angular a cause de 'clear' !! //
                                    $('.demande_inter_equipments', element).dropdown('clear'); // Réinitialise la dropdown
                                    $('.demande_inter_equipments', element).find('a.ui.label').each(function () { // Enlève tous les label de dropdown (Bug Semantic UI avec 'clear')
                                        $(this).remove();
                                    });
                                    $('.demande_inter_equipments', element).dropdown('set selected', scope.equipements); // Selectionne les prestas par défaut
                                }, 0);
                            } else { // Sinon, tous les équipements sont possibles
                                scope.baseEquipements = scope.newDemInterModal.allEquipements;
                                loadDropdown('.demande_inter_equipments'); // Init dropdown des équipements
                            }
                            loadDropdown('.equip_prestas'); // Init dropdown des équipements
                        }
                    });
                }
                scope.formLoading = false; // Fin loader
            }

            /**
             * Si plusieurs prestas possible: Initialisation de la dropdown des prestas
             * Si un seul presta possible: Affichage du prestataire possible
             * Si aucun presta possible: Affichage d'un message d'erreur
             */
            function choixPrestataire() {
                //init
                scope.newDemInterModal.equipements = []; // Equipements sélectionnés
                scope.newDemInterModal.prestataire_id = []; // Prestas sélectionnés
                scope.newDemInterModal.prestataires_ids = []; // Prestas possible
                
                // Mise à jour des équipements selectionnés
                angular.forEach(scope.baseEquipements, function (equipement) { // Pour chaque équipements possibles
                    if ($.inArray(equipement.id.toString(), scope.newDemInterModal.equipementsSelected) !== -1) { // Si celui-ci est sélectionné
                        scope.newDemInterModal.equipements.push(equipement); // Ajout de l'équipement au tableau des équipements sélectionnés
                    }
                });

                if (scope.newDemInterModal.equipements.length) { // Si au moins un équipement sélectionné
                    var all_prestas = []; // Tableau contenant les prestas de chaque équipement
                    var nb_equipements = scope.newDemInterModal.equipements.length; // Nombre d'équipements sélectionnés
                    angular.forEach(scope.newDemInterModal.equipements, function (equipement) { // Pour chaque équipements

                        if (equipement.prestataires_ids.length === undefined) { // Bug si prestataires définis sur le type d'équipement (à voir pourquoi...) => transforme equipement.prestataires_ids en tableau
                            equipement.prestataires_ids = Object.values(equipement.prestataires_ids);
                        }
                        all_prestas = all_prestas.concat(equipement.prestataires_ids); // Ajout des prestas au tableau
                    });

                    var compressedPrestaArray = compressArray(all_prestas); // Tableau contenant le nombre d'occurence de chaque prestas
                    angular.forEach(compressedPrestaArray, function (presta) { // Pour chaque entrée du tableau
                        if (presta.count === nb_equipements) { // Si un prestataire apparait autant de fois qu'il y a d'équipement sélectionné
                            scope.newDemInterModal.prestataires_ids.push(presta.value); // Ajout du presta à la liste des prestas possibles
                        }
                    });

                    scope.newDemInterModal.listePrestataires = []; // Tableau contenant le nom et le prénom des prestas possibles (Utile pour l'affichage)

                    angular.forEach(scope.newDemInterModal.equipements[0].prestataires, function (user) { // Pour chaque presta du premier équipement sélectionné
                        if ($.inArray(user.id, scope.newDemInterModal.prestataires_ids) !== -1) { // Si son ID est contenu dans le tableau des prestas possibles
                            scope.newDemInterModal.listePrestataires.push({ // Ajout du presta
                                'id': user.id,
                                'username': user.username
                            });
                        }
                    });
                } else { // Sinon, aucun presta sélectionnable
                    scope.newDemInterModal.prestataires_ids = [];
                    scope.newDemInterModal.listePrestataires = [];
                }

                if (scope.newDemInterModal.prestataires_ids.length < 2) { 
                    // Réinitialisation de la dropdown si moins de 2 prestas
                    if (scope.newDemInterModal.equipementsSelected.length > 0) {
                        if (angular.isDefined(scope.newDemInterModal.equipements) && scope.newDemInterModal.equipements.length > 0) {
                            scope.newDemInterModal.prestataire_id = [scope.newDemInterModal.equipements[0].prestataires[0].id];
                        }
                    }
                } else { // Si plusieurs prestas possibles
                    loadDropdown('.demande_inter_prestas');
                    setTimeout(function () { // !! setTimeout sinon erreur angular a cause de 'clear' !! //
                        $('.demande_inter_prestas', element).dropdown('clear'); // Réinitialise la dropdown
                        $('.demande_inter_prestas', element).find('a.ui.label').each(function () { // Enlève tous les label de dropdown (Bug Semantic UI avec 'clear')
                            $(this).remove();
                        });

                        var prestataireIDArray = scope.newDemInterModal.prestataires_ids.map(function (prestataireID) { // Transforme les valeurs en type string
                            return prestataireID.toString();
                        });
                        $('.demande_inter_prestas', element).dropdown('set selected', prestataireIDArray); // Selectionne les prestas par défaut
                    }, 0);
                }
            }

            /**
             * fonction plus nécéssaire  
             * Désactive le bouton d'envoi du formulaire
             * Si le champ Objet de la demande est vide
             * @return {Bool} 
             */
            // scope.disable_submit = function () {
            //     return $('textarea[name="newCommentaire"]', element).val() === "";
            // }; 

            /**
             * Envoi du formulaire
             * @return void
             */
            function onSubmit() {
                scope.enableMsg = false; // Désactive les messages
                scope.formLoading = true; // Loader
                if (scope.newDemInterModal.prestataire_id) { 
                    var data = {
                        file: scope.newDemInterModal.file,
                        equipements: scope.newDemInterModal.equipementsSelected,
                        prestataire_id: scope.newDemInterModal.prestataire_id.length === 1 ? scope.newDemInterModal.prestataire_id : $('.demande_inter_prestas', element).dropdown('get value'),
                        timer: scope.newDemInterModal.timer,
                        commentaire: scope.newDemInterModal.commentaire,
                        types: scope.newDemInterModal.typeSelected,
                        contact: scope.newDemInterModal.contact,
                        contact_phone: scope.newDemInterModal.contact_phone
                    };
                } else {
                    scope.newDemInterModal.flashMessage = {
                        message: 'formulaire_vide',
                        success: false
                    };
                }

                Upload.upload({
                    url: getUrlFeature('add'),
                    method: 'POST',
                    data: data
                }).then(function (response) {
                    if (response.data.success) { // Ok

                        $('#modal-nouvelle-demande-intervention-success')
                            .modal({
                                onHide : function() {
                                    initForm(); // init du formulaire pour la prochaine ouverture (afin que les dropdowns soient rechargées)
                                    $rootScope.$broadcast('DirectiveDemandeInter::demandeAdded'); // Broadcast demande ajoutée
                                }
                            })
                            .modal('show');
                    } else { // Erreur
                        if (response.data.message !== undefined) { // Message défini
                            scope.newDemInterModal.flashMessage = {
                                success: response.data.success,
                                message: response.data.message
                            };
                        }
                        else { // Sinon
                            scope.newDemInterModal.flashMessage = {
                                success: response.data.success,
                                message: 'erreur_generale'
                            };
                        }
                    }

                    scope.enableMsg = true; // Active les messages
                    scope.formLoading = false; // Fin loader
                }, function (error) {
                    scope.enableMsg = true; // Active les messages
                    scope.formLoading = false; // Fin loader
                });

            }

            /**
             * Ferme la div des messages
             */
            function closeMsg() {
                scope.enableMsg = false;
            }

            /**
             * Réinitialise le formulaire d'ajout d'équipement
             * Ouvre le formulaire d'ajout d'équipement
             * Ferme le formulaire de demande d'intervention
             */
            function openAddEquipement() {
                var form = $('.add-equipement-form', element);
                form.find('input[type=text]').each(function () { // Réinitialisation type text
                    $(this).val('');
                });
                form.find('input[type=checkbox]').each(function () { // Réinitialisation type checkbox
                    $(this).attr('checked', false);
                });
                $('.equip_prestas', element).parent('.ui.fluid.dropdown').dropdown('clear'); // Réinitialisation prestas


                $('.add-demande-inter-form', element).hide();
                form.hide();
                form.removeClass('invisible');
                form.fadeIn();
            }

            /**
             * Ferme le formulaire d'ajout d'équipement
             * Ouvre le formulaire de demande d'intervention
             */
            function closeAddEquipement() {
                scope.newDemInterModal.flashMessage = { // Réinitialisation message d'erreur pour le formualaire d'ajout d'équipement
                    success: null,
                    message: null
                };

                $('.add-equipement-form', element).hide();
                $('.add-equipement-form', element).addClass('invisible');
                $('.add-demande-inter-form', element).fadeIn();
            }

            /**
             * Ajoute un équipement sur un site choisi puis le lie aux prestataires souhaités
             */
            function addEquipement() {
                scope.formLoading = true;
                // Réinitialisation message d'erreur
                scope.newDemInterModal.flashMessage = {
                    success: null,
                    message: null
                };
                scope.enableMsg = true;
                var form = $('.add-equipement-form', element); // Formulaire de saisi
                var noeud = scope.site !== undefined ? scope.site : $('.site_demande_inter', element).dropdown('get value'); // Valeur site
                // Si site pas rempli
                if (!$.isNumeric(noeud)) {
                    // Message d'erreur
                    scope.newDemInterModal.flashMessage = {
                        success: false,
                        message: 'veuillez_renseigner_site'
                    };
                    scope.formLoading = false;
                } else {
                    // Données
                    var data = {
                        noeud: noeud,
                        nom: form.find('input[name=nom]').val(),
                        prestataires: $('.equip_prestas', element).dropdown('get value')
                    };

                    // Récupération des valeurs des caractéristiques de l'équipement
                    angular.forEach(scope.newDemInterModal.typeEquipementAutre.caracteristiques, function (caracteristique) {
                        data[caracteristique.slug] = form.find('input[name=' + caracteristique.slug + ']').val();
                    });

                    // Insertion en base
                    crudService.post(getUrlFeature('add-equipment'), data, { error_code_ignore_modal: [422] }).then(function (response) { // Requete OK
                        if (response.success) { // Traitement ok
                            $rootScope.$broadcast('DirectiveDemandeInter::equipementAdded', { added: true }); // Broadcast du succès de l'ajout de l'équipement
                            scope.newDemInterModal.allEquipements.push(response.equipement); // Ajout de l'équipement à tous les équipements
                            scope.newDemInterModal.equipementsSelected.push(response.equipement.id); // Ajout de l'équipement

                            // Determine si il faut ajouter l'équipement ou si l'équipement à déjà été ajouté (par magie...)
                            var addEquip = true; // Flag
                            // Pour chaque équipement possibles
                            angular.forEach(scope.baseEquipements, function (possibleEquipement) {
                                // Si l'id de l'équipement créé est déjà présent dedans
                                if (possibleEquipement.id == response.equipement.id) {
                                    addEquip = false; // On ne l'ajoute pas
                                }
                            });
                            if (addEquip) {
                                scope.baseEquipements.push(response.equipement); // Ajout de l'équipement à tous les équipements possibles)
                            }


                            // !! setTimeout car sinon semantic ne prend pas en compte le refresh sur la dropdown !!
                            setTimeout(function () {
                                $('.demande_inter_equipments', element).dropdown('refresh');
                                $('.demande_inter_equipments', element).dropdown('set selected', [response.equipement.id.toString()]); // Sélectionne l'équipement dans la dropdown
                            }, 0);
                            scope.closeAddEquipement(); // Ferme le formulaire d'ajout d'équipement
                        }
                        // Affichage du message
                        scope.newDemInterModal.flashMessage = {
                            success: response.success,
                            message: response.message
                        };
                        scope.formLoading = false;
                    }, function (error) { // Erreur (422)
                        // Construction du message d'erreur
                        var message = [];
                        angular.forEach(error.data, function (field) {
                            message.push(field[0]);
                        });
                        // Affichage du message d'erreur
                        scope.newDemInterModal.flashMessage = {
                            success: false,
                            message: message.join('<br>')
                        };
                        scope.formLoading = false;
                    });
                }
            }
        }
    }
})();